import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
require("highcharts/modules/exporting")(Highcharts);

export const PriceTrend = (props) => {
  // console.log(props);
  let subset = [];
  let final = [];
  let final2 = [];
  let final3 = [];
  let benchMarket = "";

  let shared_tooltip = false;
  if (props) {
    for (let i in props.data) {
      subset.push(props.data[i]["dte"]);
      subset.push(props.data[i]["final_price"]);
      final.push(subset);
      subset = [];
    }
    for (let i in props.data) {
      if (i === "0") {
        benchMarket = props.data[i]["benchmarket_market_name"];
      }
      subset.push(props.data[i]["dte"]);
      subset.push(props.data[i]["benchmarket_price"]);
      final3.push(subset);
      subset = [];
    }
    if (props.data.hasOwnProperty("0")) {
      if (props.data["0"]["arrivals"]) {
        shared_tooltip = true;
        for (let j in props.data) {
          subset.push(props.data[j]["dte"]);
          subset.push(props.data[j]["arrivals"]);
          final2.push(subset);
          subset = [];
        }
      }
    }
  }
  const options = {
    series: [
      {
        data: final,
        color: "#000080",
        yAxis: 1,
        name: "Price",
      },
      {
        data: final2,
        color: "#ff0080",
        name: "Arrivals",
      },
      {
        data: final3,
        color: "#ff1a1a",
        // visible: benchmark,
        name: "Benchmark Market Price(" + benchMarket + ")",
      },
    ],
    legend: {
      enabled: true,
    },
    exporting: {
      enabled: false,
    },
    title: {
      text: "Price Trend",
      style: {
        fontWeight: "bold",
        fontSize: "22px",
        color: "#000",
      },
    },
    subtitle: {
      text: props.crop + " " + props.market,
      style: {
        fontWeight: "bold",
        fontSize: "13px",
        color: "#000",
      },
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      crosshairs: true,
      animation: true,
      shared: shared_tooltip,
      formatter: function () {
        if (shared_tooltip === true) {
          return (
            "<b>" +
            moment(new Date(this.x)).subtract(1, "dates").format("DD") +
            " " +
            moment(new Date(this.x)).format("MMM") +
            " " +
            moment(new Date(this.x)).format("YYYY") +
            ": </b><br>" +
            this.points[0].series.name +
            ": <b>" +
            this.points[0].y +
            "</b><br>" +
            this.points[1].series.name +
            ": <b>" +
            this.points[1].y +
            "</b>"
          );
        } else {
          return (
            moment(new Date(this.x)).subtract(0, "date").format("DD") +
            " " +
            moment(new Date(this.x)).subtract(0, "months").format("MMM") +
            " " +
            moment(new Date(this.x)).subtract(0, "year").format("YYYY") +
            "</b>: <b>" +
            this.y +
            "</b>"
          );
        }
      },
    },
    rangeSelector: {
      allButtonsEnabled: true,
      buttons: [
        {
          type: "week",
          count: 1,
          text: "1W",
          dataGrouping: {
            forced: true,
            units: [["day", [1]]],
          },
        },
        {
          type: "month",
          count: 1,
          text: "1M",
          dataGrouping: {
            forced: true,
            units: [["day", [1]]],
          },
        },
        {
          type: "month",
          count: 3,
          text: "3M",
          dataGrouping: {
            forced: true,
            units: [["day", [1]]],
          },
        },
        {
          type: "month",
          count: 6,
          text: "6M",
          dataGrouping: {
            forced: true,
            units: [["day", [1]]],
          },
        },
        {
          type: "year",
          count: 1,
          text: "1Y",
          dataGrouping: {
            forced: true,
            units: [["day", [1]]],
          },
        },
        {
          type: "year",
          count: 2,
          text: "2Y",
          dataGrouping: {
            forced: true,
            units: [["day", [1]]],
          },
        },
        {
          type: "all",
          text: "All",
          title: "All",
        },
      ],
      buttonTheme: {
        width: 60,
      },
      selected: 6,
    },
    xAxis: {
      type: "datetime",
      lineWidth: 1,
      lineColor: "#515151",
      tickColor: "#515151",
      tickInterval: 30 * 24 * 3600 * 1000,
      labels: {
        useHTML: true,
        style: {
          fontSize: "10px",
          padding: "10px",
        },
      },
    },
    yAxis: [
      {
        // Primary yAxis
        labels: {
          format: "{value}",
          style: {
            color: "#ff0080",
          },
        },
        title: {
          text: "Arrivals (q)",

          style: {
            color: "#ff0080",
          },
        },
      },
      {
        // Secondary yAxis
        title: {
          text: "Prices (INR Quintals)",

          style: {
            color: "#000080",
          },
        },
        labels: {
          format: "{value}",
          style: {
            color: "#000080",
          },
        },
        opposite: false,
      },
    ],
    // exporting: {
    //   buttons: [
    //     {
    //       text: "Benchmark",
    //       onclick: function () {
    //         setBenchmark(true);
    //         alert("You pressed the button!");
    //       },
    //       theme: {
    //         "stroke-width": 1,
    //         stroke: "silver",
    //         r: 0,
    //         states: {
    //           hover: {
    //             fill: "#a4edba",
    //           },
    //           select: {
    //             stroke: "#039",
    //             fill: "#a4edba",
    //           },
    //         },
    //       },
    //     },
    //   ],
    // },
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={"stockChart"}
      options={options}
    />
  );
};
